export default __webpack_public_path__ + "static/char-s-42-ja-6976444601075ec79fc8ea4b5a1ef114.png";